import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { type Components, type Theme } from '@mui/material/styles';

const MuiSelect: Components<Theme>['MuiSelect'] = {
  defaultProps: {
    IconComponent: KeyboardArrowDownIcon
  }
};

export const select = { MuiSelect };
